import { assertEvent, enqueueActions } from 'xstate5';

import { DRESSINGS } from '../../customization.machine.constants';
import { findActiveModification, getDressingPortionSize } from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Raises the corresponding events to increase or decrease the weight based
 * on the provided weight.
 */
export const changeDressingWeight: CustomizationMachineAction = enqueueActions(
  ({ enqueue, event, context }) => {
    assertEvent(event, 'customization.dressing.change-weight');

    const { modifications, mixedDressingDetails } = context;
    const { ingredientId, weight } = event;

    const activeModifications = modifications?.active ?? [];
    const activeModification = findActiveModification(ingredientId, activeModifications); // prettier-ignore

    if (!activeModification) return;

    const currentWeightIndex = getDressingPortionSize(activeModification, mixedDressingDetails); // prettier-ignore
    const weightIndex = DRESSINGS.WEIGHT_PORTIONS_MAP[weight];

    const changesCount = weightIndex - currentWeightIndex;
    const numberOfActions = Math.abs(changesCount);
    const operations = Array.from({ length: numberOfActions });

    const shouldIncreaseWeight = changesCount > 0;
    const shouldDecreaseWeight = changesCount < 0;

    if (changesCount === 0) return;

    const increaseWeight = () => enqueue.raise({ type: 'customization.dressing.increase-weight', ingredientId }); // prettier-ignore
    const decreaseWeight = () => enqueue.raise({ type: 'customization.dressing.decrease-weight', ingredientId }); // prettier-ignore

    if (shouldDecreaseWeight) operations.forEach(decreaseWeight);
    if (shouldIncreaseWeight) operations.forEach(increaseWeight);
  },
);
